import { useEffect } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { ROUTES } from "routing/routes";

import { Box, Link, Logo, Stack, Text } from "@seneca/senekit";

import { mailToLink } from "common/links";

import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";
import { logMessage } from "seneca-common/utils/sentry/logError";

import Card from "features/common/components/Card";
import { linkToDashboard } from "features/dashboard/links";

import CopyDiagnosisCode from "./components/CopyDiagnosisCode";
import HelpBulletPoints from "./components/HelpBulletPoints";

export default function DiagnosisPage() {
  const navigate = useNavigate();

  const { noUpdateRedirect } = useTypedState(ROUTES.DIAGNOSIS);

  useEffect(() => {
    if (!noUpdateRedirect) {
      navigate(ROUTES.UPDATE.buildPath({}), {
        state: {
          redirectState: {
            noUpdateRedirect: true
          },
          redirectPostUpdate: ROUTES.DIAGNOSIS.path
        }
      });
    }
  }, [navigate, noUpdateRedirect]);

  useEffect(() => {
    if (noUpdateRedirect) {
      logMessage("Visited diagnosis page");
    }
  }, [noUpdateRedirect]);

  return (
    <Box marginTop="xxlarge" marginX={["medium", "none"]}>
      <Stack align="center" space="xxlarge">
        <Link to={linkToDashboard()}>
          <Logo width={["200px", "330px"]} />
        </Link>
        <Card rounded>
          <Box padding="xxlarge" maxWidth="750px">
            <Stack space="large">
              <Text>
                If you're having trouble, this page can help you diagnose any
                issues you are experiencing.
              </Text>
              <HelpBulletPoints />

              <CopyDiagnosisCode />
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection={["column", "row"]}
              >
                <Text>Get in touch at&nbsp;</Text>
                <Link to={mailToLink}>learnmore@seneca.io</Link>
              </Box>
            </Stack>
          </Box>
        </Card>
      </Stack>
    </Box>
  );
}
